import { EToastType, toast } from '@bfe/moly';
import { useEffect, useRef, useState } from 'react';

import { useI18nContext } from '@/i18n/I18n';
import { getRiskStrategyApi } from '@/services/security';
import { SecurityComponentTrack } from '@/utils/trace-list/security-component';

interface ISecurityResponse {
  result: {
    risk_token: string;
  };
}

interface IProps {
  scene?: string;
  show?: boolean;
  risk_token?: string;
  showFailToast?: boolean;
  onSuccess: (risk_token: string) => void;
  onClose: (risk_token_type?: string, riskToken?: string) => void;
  onFail?: (error: any) => void;
  onGetRiskTokenFail?: (e: any) => void;
  closeCallbackAfterSuccess?: boolean;
}

const SecurityComponent = ({
  show,
  scene,
  risk_token,
  showFailToast = true,
  onSuccess,
  onFail,
  onClose,
  onGetRiskTokenFail,
  closeCallbackAfterSuccess = true,
}: IProps) => {
  const [$t] = useI18nContext();

  const [showRiskToken, setShowRiskToken] = useState(risk_token);
  const [riskTokenType, setRiskTokenType] = useState('');
  const securityInstanceRef = useRef<any>();

  const getStrategy = async (scene: string) => {
    try {
      const rs: any = await getRiskStrategyApi({ sence: scene });
      const {
        result: { risk_token, risk_token_type },
      } = rs;
      if (risk_token_type === 'pass') {
        onSuccess(risk_token);
        onClose();
      } else if (risk_token) {
        setShowRiskToken(risk_token);
        setRiskTokenType(risk_token_type);
      }
    } catch (error: any) {
      if (showFailToast) {
        const title =
          typeof error?.ret_msg === 'string' && error?.ret_msg !== ''
            ? error?.ret_msg
            : $t('networkError');
        toast({
          iconType: EToastType.WARN,
          title,
        });
      }
      if (typeof onGetRiskTokenFail === 'function') {
        onGetRiskTokenFail(error);
      } else {
        onFail?.(error);
        onClose();
      }
      SecurityComponentTrack(scene, 'default-intercept', error);
    }
  };

  useEffect(() => {
    if (typeof show == 'undefined' || show) {
      // 传入 risk_token 时，只做安全组件校验，不需要获取新的 risk_token
      if (!risk_token && scene) {
        getStrategy(scene);
        console.log('security component: ', risk_token, scene);
      } else if (risk_token && !scene) {
        setShowRiskToken(risk_token);
      }
    }
  }, [risk_token, scene, show]);

  console.log('security component 2: ', show, showRiskToken);

  const clearTokenHandler = () => {
    onClose?.(riskTokenType, showRiskToken);
    setShowRiskToken('');
    if (securityInstanceRef.current) {
      securityInstanceRef.current.dealloc();
    }
  };

  const callBack = (res: any) => {
    onSuccess?.(res?.result.risk_token);
    setShowRiskToken('');
  };

  const riskTokenPass = (res: ISecurityResponse) => {
    callBack(res);
    if (closeCallbackAfterSuccess) {
      clearTokenHandler();
    }
  };

  const faceFailHandler = () => {
    onClose?.();
    setShowRiskToken('');
  };

  if (show && showRiskToken) {
    // if (securityInstanceRef.current) {
    //   securityInstanceRef.current.dealloc();
    // }
    // 与react编写交互时，注意react的fiber生命周期与window不一样
    window.BybitUniFrame?.ready(({ security }: any) => {
      securityInstanceRef.current = security;
      console.log(securityInstanceRef.current);
      const {
        USE_NEW_SECURITY_VERIFICATION_NOT_AVAILABLE,
        VISIBLE,
        USER,
        RISK_TOKEN,
      } = security.properties;

      security.setProperty(USE_NEW_SECURITY_VERIFICATION_NOT_AVAILABLE, true);

      const { SAVE_HANDLER, CANCEL_HANDLER, CLOSE_MODAL_HANDLER, ON_KYC_FAIL } =
        security.events;

      // 安全项配置重置
      const resetHandler = () => {
        security.setProperty(USER, { username: '' });
        security.setProperty(RISK_TOKEN, null);
        security.setProperty(VISIBLE, false);
        security.unsubscribeEvent(SAVE_HANDLER, riskTokenPass);
        clearTokenHandler();
      };

      const faceFailOrClose = (res: any) => {
        console.info(res, ' ---- res ----');
        if (res) {
          // 自行关闭
          resetHandler();
        } else if (faceFailHandler) {
          // 3波验证都失败（9次）
          faceFailHandler && faceFailHandler();
        } else {
          // 兜底逻辑关闭, 可以不用配置人脸验证失败，默认走关闭逻辑
          resetHandler();
        }
      };

      security.setProperty(USER, {
        username: '',
        country_code: '',
      });
      security
        .subscribeEvent(CLOSE_MODAL_HANDLER, resetHandler)
        .subscribeEvent(CANCEL_HANDLER, resetHandler);
      security.subscribeEvent(ON_KYC_FAIL, faceFailOrClose);
      security.setProperty(RISK_TOKEN, showRiskToken);
      security.setProperty(VISIBLE, true);
      security.subscribeEvent(SAVE_HANDLER, riskTokenPass);
    });
  } else {
    if (securityInstanceRef.current) {
      console.log('securityInstanceRef 2');
      const { VISIBLE } = securityInstanceRef.current.properties;
      securityInstanceRef.current.setProperty(VISIBLE, false);
      securityInstanceRef.current.dealloc();
    }
  }

  return <></>;
};

export default SecurityComponent;
